import { Stack, TextField } from '@fluentui/react';
import { SendIcon } from '@fluentui/react-northstar';
import React, { useState, Dispatch, useEffect } from 'react';
import CloudUpload from '@material-ui/icons/CloudUpload';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Dropzone from 'react-dropzone';
import { ENTER_KEY, EMPTY_MESSAGE_REGEX, MAXIMUM_LENGTH_OF_MESSAGE } from '../../src/constants';
import {
  sendBoxStyle,
  sendIconStyle,
  textFieldStyle, TextFieldStyleProps, containerStyles, dropzone
} from './styles/SendBox.styles';
import { User } from '../core/reducers/ContosoClientReducers';
import { ClientChatMessage } from '../core/reducers/MessagesReducer';
import {
  localStorageAvailable,
  getDisplayFirstNameFromLocalStorage,
  getDisplayLastNameFromLocalStorage
} from '../Utils/localStorage';
import FileUpload from "../assets/FileUpload.png";
import { createSendFiles } from '../core/chatSideEffects';

export interface SendboxProps {
  onSendMessage(messageContent: string): void;
  onSendTypingNotification(
    lastSentTypingNotificationDate: number,
    setLastSentTypingNotificationDate: Dispatch<number>
  ): void;
  user: User;
  messages: ClientChatMessage[];
  loader: any;
  onSendFiles(files: any): void;
}

export default (props: SendboxProps): JSX.Element => {
  const [textValue, setTextValue] = useState('');
  const [textValueOverflow, setTextValueOverflow] = useState(false);
  const [lastSentTypingNotificationDate, setLastSentTypingNotificationDate] = useState(0);
  const username = localStorageAvailable ? (getDisplayFirstNameFromLocalStorage() + ' ' + getDisplayLastNameFromLocalStorage()) : '';
  const firstname = localStorageAvailable ? (getDisplayFirstNameFromLocalStorage()) : '';
  const lastname = localStorageAvailable ? (getDisplayLastNameFromLocalStorage()) : '';
  useEffect(() => {
    var messages = props.messages;
    var findMsg = messages.find((find: any) => find.senderDisplayName === username);
    if (!findMsg) {
      // props.onSendMessage(`You are connected live with the Duty Officer Vidhayardhi Gorrepati. How can I assist you? Thanks!`);
    }
  }, []);

  const addMessage = () => {
    // we dont want to send empty messages including spaces, newlines, tabs
    if (!EMPTY_MESSAGE_REGEX.test(textValue)) {
      props.onSendMessage(textValue);
      setTextValue('');
    }
  };

  const setText = (e: any) => {
    if (e.target.value.length > MAXIMUM_LENGTH_OF_MESSAGE) {
      setTextValueOverflow(true);
    } else {
      setTextValueOverflow(false);
    }
    setTextValue(e.target.value);
  };

  const changeHandler = (files: any) => {
    // console.log(event.target.files.length)
    if (files.length > 0) {
      // var files = event.target.files;
      var newText = '';
      for (let i = 0; i < files.length; i++) {
        const element = files[i];
        newText += '<p>' + element.name + ' ' + 'Uploaded Successfully, ' + '</p>' + '\n'
      }
      var convertText = newText.replace(/<[^>]+>/g, '');
      if (!props.loader) {
        props.onSendFiles(files);
      }
      // props.onSendMessage(convertText);
    }
  };

  return (
    <div className={containerStyles+' mob_files_upload'}>
      <Stack horizontal={true}>
        {/* <SendIcon
          outline
          className={sendIconStyle}
          id="sendmessage"
        onClick={() => {
          if (!textValueOverflow) {
            addMessage();
          }
        }}
        /> */}
        {/* <input
          multiple
          id="icon-button-file"
          type="file"
          style={{ display: 'none' }}
          onChange={changeHandler}
        />
        <Tooltip placeholder='top' title='Upload files'>
          <label htmlFor="icon-button-file" className={sendIconStyle}>
            <IconButton color="primary" aria-label="upload picture"
              component="span" style={{ padding: '8px' }}>
              <img src={FileUpload} alt="File Upload" style={{ width: '1.7rem' }} />
            </IconButton>
          </label>
        </Tooltip> */}
        <Dropzone onDrop={changeHandler} multiple={true}>
          {({ getRootProps, getInputProps }) => (
            <section>
              <div {...getRootProps({ className: dropzone })}>
                <input {...getInputProps()} />
                <Tooltip placeholder='top' title='Upload files'>
                  <label className={sendIconStyle}>
                    <IconButton color="primary" aria-label="upload picture"
                      component="span" style={{ padding: '8px' }}>
                      <img src={FileUpload} alt="File Upload" style={{ width: '1.7rem' }} />
                    </IconButton>
                  </label>
                </Tooltip>
              </div>
            </section>
          )}
        </Dropzone>
        <div style={{ padding: '5px', background: '#ffffff', width: '350px', border: '1px solid #ccc', borderRadius: '5px', right: '10px', marginBottom: '18px' }}>
          <TextField
            className={textFieldStyle}
            id="sendbox"
            borderless={true}
            style={{ background: '#fff' }}
            ariaLabel={'Type'}
            inputClassName={sendBoxStyle}
            placeholder="Type your message"
            value={textValue}
            onChange={setText}
            autoComplete="off"
            onKeyUp={(ev) => {
              if (ev.which === ENTER_KEY && !textValueOverflow) {
                addMessage();
              }
              props.onSendTypingNotification(lastSentTypingNotificationDate, setLastSentTypingNotificationDate);
            }}
            styles={TextFieldStyleProps}
          />
        </div>
      </Stack>
    </div>
  );
};
